import { render, staticRenderFns } from "./NameAndAdress.vue?vue&type=template&id=b9b97782&scoped=true&"
import script from "./NameAndAdress.vue?vue&type=script&lang=js&"
export * from "./NameAndAdress.vue?vue&type=script&lang=js&"
import style0 from "./NameAndAdress.vue?vue&type=style&index=0&id=b9b97782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b97782",
  null
  
)

export default component.exports